// Chakra imports
import {
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
  IconButton,
  Input,
  Select,
  InputGroup,
  InputLeftElement,
  useDisclosure,
   Box, Button,
       Stack, Flex, Text, useColorModeValue

       } from "@chakra-ui/react";
import React from "react";
import Authors from "./components/Authors";
import Projects from "./components/Projects";
import { tablesTableData, dashboardTableData } from "variables/general";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import { motion } from "framer-motion";

import { useParams, useHistory } from 'react-router-dom';

const countryValues = [
    { id: 'd', label: 'Germany'},
    { id: 'f', label: 'France'},
    { id: 'i', label: 'Italy'},
    { id: 'j', label: 'Jewish Law'},
    { id: 'nl', label: 'Netherlands'},
    { id: 'pt', label: 'Portugal'},
    { id: 's', label: 'Spain'},
    { id: 'sc', label: 'Scandinavia'},
    { id: 'uk', label: 'United Kingdom'},
    { id: 'us', label: 'United States'},
    { id: 'va', label: 'Vatican'}
]

const steps = [
  { title: 'Initial', description: 'Define document id' },
  { title: 'Metadata', description: 'Fields about the document' },
  { title: 'Commentary', description: 'Commentary and metadata' },
  { title: 'Representation', description: 'Translations/ Transcriptions and Scans' },
]

const activeStepComponentTypeMap = {
    1: 'record',
    2: 'commentary',
    3: 'representation'
}
function TablesAdd(props) {
  const { getButtonProps, getDisclosureProps, isOpen } = useDisclosure();
  const [hidden, setHidden] = React.useState(!isOpen);
  const [countryId, setCountryId] = React.useState("");
  const [yearId, setYearId] = React.useState("");
  const [generatedDocumentId, setGeneratedDocumentId] = React.useState("");

  const dataIds = props.data.map((item) => {
    return item.id.replace("record_", "");
  });

    const history = useHistory();

  let mainText = useColorModeValue("gray.700", "gray.200");
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  })

  React.useEffect(() => {
    if (activeStep > 0) {
        const loginForm = document.getElementById('loginForm');
        loginForm.style.display = 'none';
        loginForm.submit();
    }
  }, [activeStep]);

    const changeIframe = () => {
        const loginForm = document.getElementById('loginForm');
        loginForm.style.display = 'none';
        loginForm.submit();
    }

    const createNewDocument = () => {
        const loginForm = document.getElementById('loginForm');

        document.getElementById("loginFormRecord").setAttribute("name","record");
        loginForm.submit();

        setTimeout(() => {
            document.getElementById("loginFormRecord").setAttribute("name","commentary");
            loginForm.submit();
            setTimeout(() => {
                document.getElementById("loginFormRecord").setAttribute("name","representation");
                loginForm.submit();
                setTimeout(() => {


                    setActiveStep(1);
//                    document.getElementById("loginForm").setAttribute("action","POST");
//                    document.getElementById("loginForm").setAttribute("action","https://www.copyrighthistory.org/cam/tools/manager/editor-admin.php");
//                    document.getElementById("loginFormRecord").setAttribute("name","representation");
//                    document.getElementById("loginFormAction").setAttribute("value","show");
//
//                    loginForm.style.display = 'block';
//                    loginForm.submit();
                }, 500);
            }, 200);
        }, 200);
    }




  React.useEffect(() => {
    if(yearId && countryId) {
        let origDocId = countryId + "_" + yearId;
        let docId = countryId + "_" + yearId;

        const alphabet = "abcdefghijklmnopqrstuvwxyz";
        let alphabetIndex = -1;
        while(dataIds.includes(docId)) {
            alphabetIndex = alphabetIndex + 1;
            docId = origDocId + alphabet[alphabetIndex];
            console.debug({dataIds, docId})
        }
        setGeneratedDocumentId(docId);
    } else {
        setGeneratedDocumentId("");
    }
  }, [yearId, countryId]);

  const { document_id } = useParams();
  const textColor = useColorModeValue("gray.700", "white");

  const activeStyle = {
                                  background: 'var(--chakra-colors-yellow-700)',
                                  color: '#fff'
                              }
  const inactiveStyle = {
                                  borderColor: 'var(--chakra-colors-yellow-700)',
                                  color: 'var(--chakra-colors-yellow-700)'
                              }
  return (

    <Flex style={{ height: 'calc(100% - 64px)', width: 'calc(100% - 64px)', position: 'absolute' }}
        direction='column' pt={{ base: "0px", md: "0px" }}
    >
      <form id="loginForm" style={{ display: 'none'}} target="myFrame" action={activeStep > 0 ? "https://www.copyrighthistory.org/cam/tools/manager/editor-admin.php" : "https://www.copyrighthistory.org/cam/tools/manager/manager-admin.php"} method={activeStep > 0 ? "POST" : "GET"}>
        <input id="loginFormRecord" type="text" name={activeStep > 0 ? "id" : "record"} value={activeStep > 0 ? (activeStepComponentTypeMap[activeStep] + "_" + generatedDocumentId) : generatedDocumentId} />
        <input id="loginFormAction" type="text" name="action" value={activeStep > 0 ? "show" : "new"} />
        <input type="submit" />
      </form>


<motion.div
        {...getDisclosureProps()}
        hidden={hidden}
        initial={false}
        onAnimationStart={() => setHidden(false)}
        onAnimationComplete={() => setHidden(!isOpen)}
        animate={{ width: isOpen ? '100%' : '0%' }}
        style={{
          background: "transparent",
          overflow: "hidden",
          whiteSpace: "nowrap",
          position: "absolute",
          top: "-30px",
          left: "-54px",
          zIndex: 999,
          right: "0",
          height: "100vh",
        }}
      >
      <div style={{ height: '100%', width: '100%' }}>
                  <iframe id="previewFrame" src={"https://www.copyrighthistory.org/cam/tools/request/showRecord.php?id=record_" + generatedDocumentId} style={{ height: '100%', width: '100%' }}>
                    Your browser does not support inline frames.
                  </iframe>
                  </div>
      </motion.div>

      <button
      onClick={() => {
        document.getElementById('previewFrame').src += ' ';
        getButtonProps().onClick();
      }}
      style={{ position: 'fixed', opacity: activeStep > 0 ? 1 : 0,
      top: 0, right: 0, padding: '1em', zIndex: 9999,
      color: 'white', fontWeight: 800, borderBottomLeftRadius: 15,
       background: 'rgb(181 123 108)' }} >TOGGLE Preview</button>


<Card style={{ background: 'white' }} b='white' p='16px'  overflowX={{   }}>
    <Stepper colorScheme='green' size='lg' index={activeStep}>
      {steps.map((step, index) => (
        <Step key={index} style={{ cursor: 'pointer' }} onClick={() => {
            setActiveStep(index);
        }}>
          <StepIndicator>
            <StepStatus
              complete={<StepIcon />}
              incomplete={<StepNumber />}
              active={<StepNumber />}
            />
          </StepIndicator>

          <Box flexShrink='0'>
            <StepTitle>{step.title}</StepTitle>
          </Box>

          <StepSeparator />
        </Step>
      ))}
    </Stepper>
</Card>
<br />

<Card style={{ background: 'white' }} b='white' p='16px' h='100%' overflowX={{ sm: "scroll", height: '100%' }}>
    <CardHeader p='0px 0px' mb='0px'>
        <Flex direction='column'>
          <Text fontSize='lg' color={textColor} fontWeight='bold'>
            { (activeStep !== 3 && activeStep > 0) && <div>
              <Button onClick={ () => { setActiveStep(activeStep+1); }} colorScheme='green' variant='outline'>
                Proceed to { activeStepComponentTypeMap[activeStep+1] }
              </Button>
              <span style={{ paddingLeft: '1em', fontStyle: 'italic', color: 'red' }}>
              Please make sure to press SUBMIT at the end of the document below before you proceed</span>
            </div> }
            { (activeStep === 3) && <div>
                          <Button onClick={ () => {

                          let text = "Are you sure you want to finish the document creation and return to Dashboard? Please make sure to verify through the preview button in the top right if images, translations and transcriptions are showing up correctly. Press ok to return to dashboard or cancel to stay on this page.";

                            if (confirm(text) == true) {

                            props.fetchData();
                            // navigate to route "admin/dashboard"
                            history.push('/admin/dashboard');



                            } else {
                            }

                            }} colorScheme='green' variant='outline'>
                            Return to Dashboard
                          </Button>
                          <span style={{ paddingLeft: '1em', fontStyle: 'italic', color: 'red' }}>
                            Please make sure to press SUBMIT at the end of the document below before you return to Dashboard</span>
                          <p>
                            You can also look at a preview of how the record will look like on the website by clicking the button on the top right
                          </p>
                        </div> }
            { activeStep === 0 && <span>
                Let's define our document id by selecting the country and year, an id will automatically be generated for it:
            </span> }
          </Text>
        </Flex>
      </CardHeader>

      {activeStep === 0 && <div>
      <br />
        <p>
    <Select
        style={{ borderRadius: 0 }}
      rootProps={{  style:{ paddingLeft: 0, borderRadius: 0, paddingTop: 5,  paddingBottom: 5, maxWidth: 300 } }}
        fontSize="l"
        py="26px"
        onChange={(e) => {
            setCountryId(e.target.value)
        }}
         placeholder='Filter by Country'>
         {countryValues.map((country) => (
            <option value={country.id}>{country.label}</option>
            ))}
      </Select>
        </p>
        <p>


        <Input

        onChange={(e) => {
            setYearId(e.target.value)
        }}
          fontSize="m"
          py="26px"
          type="number"
          color={mainText}
          placeholder="Enter the year of the document..."
          borderRadius="inherit"
          style={{ maxWidth: 300 }}
        />

        </p>
        <br/>
        <p style={{ paddingLeft: '1em', color: 'grey' }}>

        Generated document id: <span style={{ color: '#b67a6a', fontWeight: 800 }}> {generatedDocumentId ? generatedDocumentId : '-'} </span>
        </p>

        <br />

        <Button

        onClick={() => {
//            setActiveStep(1);
              createNewDocument(generatedDocumentId);
        }}
        style={{
        background: generatedDocumentId ? 'var(--chakra-colors-yellow-700)' : 'grey',
        opacity: generatedDocumentId ? 1. : .5,
        cursor: generatedDocumentId ? '' : 'not-allowed',
        pointerEvents: generatedDocumentId ? '' : 'none',
         color: 'white', fontWeight: 800, borderRadius: 0}} >PROCEED</Button>

      </div>

      }

      { <div style={{ opacity: activeStep > 0 ? 1 : 0, height: '100%', width: '100%' }}>
            <iframe name="myFrame" src="#" style={{ height: '100%', width: '100%' }}>
              Your browser does not support inline frames.
            </iframe>
            </div> }
</Card>


    </Flex>
  );
}

export default TablesAdd;
